import { useQuery, type Query } from "@tanstack/react-query"
import type { KnowledgeDocumentDetail } from "../../domain/entities/document"
import { makeGetDocumentById } from "../../domain/use-cases/get-document-by-id"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const getDocumentById = makeGetDocumentById(httpDocumentRepository)

type RefetchInterval =
  | number
  | false
  | ((query: Query<KnowledgeDocumentDetail, Error>) => number | false | undefined)

type UseDocumentOptions = {
  refetchInterval?: RefetchInterval
}

export const useDocument = (
  id: string | null,
  options: UseDocumentOptions = {},
) =>
  useQuery({
    queryKey: ["document", id],
    queryFn: () => getDocumentById(id as string),
    enabled: !!id,
    refetchInterval: options.refetchInterval ?? false,
  })
